import React from "react";
import PropTypes from "prop-types";

import moment from "moment";
import { Twemoji } from "react-emoji-render";

export default function RestaurantReview(props) {
  const review = props.review;
  console.log(review);
  if (!review.category) {
    review.category = {};
    review.category = review.category ? review.category : props.defaultCategory;
  }
  let date = "";
  const dateDay = moment(review.date)
    .format("DD")
    .toString();
  const dateMonth = moment(review.date)
    .format("MM")
    .toString()
    .toLowerCase();
  const dateYear = moment(review.date)
    .format("YYYY")
    .toString();
  date = `${dateDay}/${dateMonth}/${dateYear}`;
  // let dateResponse = "";
  // if (
  //   review.blobId &&
  //   review.blobId.comment &&
  //   review.blobId.comment.text &&
  //   !(
  //     review.blobId.comment.abuse &&
  //     review.blobId.comment.abuse.status === "confirmed"
  //   )
  // ) {
  //   const dateResponseDay = moment(review.checkInDate)
  //     .format("DD")
  //     .toString();
  //   const dateResponseMonth = moment(review.checkInDate)
  //     .format("MM")
  //     .toString()
  //     .toLowerCase();
  //   const dateResponseYear = moment(review.checkInDate)
  //     .format("YYYY")
  //     .toString();
  //   dateResponse = `${dateResponseDay} ${dateResponseMonth} ${dateResponseYear}`;
  // }
  let score = review.score.find(sc => sc.name === "total");
  if (score) {
    score = Number(score.score).toFixed(1);
  }
  if (score >= 10) {
    score = "10";
  }
  // let reviewedAs = "";

  const getCircleScore = type => {
    const review = props.review;
    let score = null;
    let find = null;
    // console.log(review);
    if (type === "price") {
      find = review.price;
    } else {
      find = review.score.find(el => el.name === type); //[type];
      if (find && find.score) {
        find = find.score;
      }
    }
    if (find && !isNaN(Number(find))) {
      score = Number(find);
    } else {
      score = 0;
    }
    // }
    if (score >= 10 && type !== "price") {
      score = "10";
    }
    // score = review.serviceScore ? review.serviceScore.toFixed(1) : '-'
    return <div className={"RestaurantInfo-rating-plain"}>{score}</div>;
  };

  // console.log("review", review);

  return (
    <div className="extendedReview">
      <div className="reviewHead">
        <div className="reviewAuthor">
          <div className="Restaurant-detail-username">
            {review.userId && review.userId && review.userId.profileImageUrl ? (
              <img
                alt={`${review.userId.username}`}
                title={`${review.userId.username}`}
                src={review.userId.profileImageUrl}
                style={{ width: "50px", height: "50px", marginRight: "15px" }}
              />
            ) : null}
            {review.userId.username}
            {/* {review.category.id !== 100 ? (
              <div
                style={{
              fontSize: "12px",
              textAlign: "left",
              marginTop: "0",
              lineHeight: "17px",
              fontWeight: "normal"
                }}
                className="RestaurantInfo-rating-menu extendedInfo review-above"
              >
                <div>Recensito come</div>
                <div style={{ fontSize: "14px", fontWeight: "bold" }}>
              {reviewedAs}
                </div>
              </div>
            ) : null} */}
          </div>
          <div
            className="Restaurant-detail-title"
            style={{
              fontSize: "35px",
              float: "right",
              marginTop: "5px",
              fontWeight: "bold"
            }}
          >
            {score}
          </div>
        </div>
        <div className="reviewRatings">
          {
            <div
              className="RestaurantInfo-rating-container"
              style={{ marginRight: "20px", float: "left" }}
            >
              {getCircleScore("menu", false)}
              <div
                style={{ fontSize: "16px", lineHeight: "16px" }}
                className="RestaurantInfo-rating-menu"
              >
                Menu
              </div>
            </div>
          }
          {
            <div
              className="RestaurantInfo-rating-container"
              style={{ marginRight: "20px", float: "left" }}
            >
              {getCircleScore("location", false)}
              <div
                style={{ fontSize: "16px", lineHeight: "16px" }}
                className="RestaurantInfo-rating-menu"
              >
                Location
              </div>
            </div>
          }
          {
            <div
              className="RestaurantInfo-rating-container"
              style={{ marginRight: "20px", float: "left" }}
            >
              {getCircleScore("service", false)}
              <div
                style={{ fontSize: "16px", lineHeight: "16px" }}
                className="RestaurantInfo-rating-menu"
              >
                Servizio
              </div>
            </div>
          }
          {review && review.price ? (
            <div
              className="RestaurantInfo-rating-container"
              style={{ float: "left" }}
            >
              {/* <meta itemProp="priceRange" content={`${minimumPrice}-${maximumPrice}`} /> */}
              {getCircleScore("price", false)}
              <div
                style={{ fontSize: "16px", lineHeight: "16px" }}
                className="RestaurantInfo-rating-menu"
              >
                Prezzo
              </div>
            </div>
          ) : null}
        </div>
        {/* <div className="RestaurantInfo-rating-menu extendedInfo review-below">
          <div>Recensito come</div>
          <div style={{ fontSize: "14px", fontWeight: "bold" }}>
            {reviewedAs}
          </div>
        </div> */}
      </div>
      <div style={{ width: "100%", float: "left" }} />
      <div
        style={{
          fontSize: "16px",
          textAlign: "left",
          marginTop: "0",
          lineHeight: "21px",
          float: "left"
        }}
        className="RestaurantInfo-rating-menu extendedInfo"
      >
        Recensito il{" "}
        <span
          style={{ fontSize: "18px", lineHeight: "24px", fontWeight: "bold" }}
        >
          {date}
        </span>
      </div>
      {review.blob && review.blob ? (
        <div className="restaurat-detail-review-blob">
          <div>
            <span>
              {'"'}
              <Twemoji text={`${review.blob}`} />
              {'"'}
            </span>
          </div>
          {review.ownerReply ? (
            <div style={{ marginTop: "15px" }}>
              <div style={{ width: "100%", display: "inline-block" }}>
                <div
                  className="restaurant-detail-review-comment-madeBy"
                  style={{ float: "left" }}
                >
                  Risposta del proprietario
                </div>
              </div>

              <div className="restaurant-detail-review-comment">
                <Twemoji text={`${review.ownerReply}`} />
              </div>
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}

RestaurantReview.propTypes = {
  review: PropTypes.object.isRequired,
  attributes: PropTypes.object,
  defaultCategory: PropTypes.number.isRequired
};
RestaurantReview.defaultProps = {
  attributes: {}
};
